import React, { useMemo, useState } from "react";

import { useRequiredPermissions } from "helpers";

import SearchResultSection from "./searchResultSection";

export const useSearchSection = (section, pattern, isEnabled = false) => {
	const [page, setPage] = useState<number>(0);
	const [open, setOpen] = useState<boolean>(false);

	const hasSearchPermissions = useRequiredPermissions(
		section.requiredPermissions,
	);

	const queryResult = section.useSearchQuery({
		pattern,
		page,
		options: {
			enabled: hasSearchPermissions && isEnabled,
		},
	});

	const SectionComponent = useMemo(() => {
		const Component = props => {
			if (hasSearchPermissions && queryResult.isError) {
				return null;
			}
			return (
				<SearchResultSection
					name={section.name}
					title={section.title}
					renderItem={section.renderItem}
					getIcon={section.getIcon}
					getLink={section.getLink}
					data={queryResult.data}
					loading={queryResult.isFetching}
					page={page}
					setPage={setPage}
					open={open}
					setOpen={setOpen}
					{...props}
				/>
			);
		};
		return Component;
	}, [
		hasSearchPermissions,
		open,
		page,
		queryResult.data,
		queryResult.isError,
		queryResult.isFetching,
		section.getIcon,
		section.getLink,
		section.name,
		section.renderItem,
		section.title,
	]);

	return { ...queryResult, SectionComponent };
};
